const initialAutomationState = { data: [], loading: true };

export const GetMessageAutomationData = (state = initialAutomationState, action) => {
  switch (action.type) {
    case "get_messageAutomationData":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
